import { useAuth } from "@/data/context/authContext";
import { Navigate } from "react-router-dom";
import ROUTES from "@/data/Routes";
import { ROLES } from "@/data/interfaces/RolesEnum";
import AdminPanel from "@/components/Account/Admin/AdminPanel";
import DoctorPanel from "@/components/Account/Doctor/DoctorPanel";
import { isUserInfoFilled } from "@/utils/isUserInfoFilled";
import Loading from "@/components/Loading";
import { UserJourneyPanel } from "@/components/Account/UserJourneyPanel";
import AccountCreationForm from "@/components/Registration/AccountCreationForm";
import userService from "@/services/userService";
import { NewUserData } from "@/data";

const Account = () => {
  const { user, loadUser } = useAuth();
  const isEmailVerified = !!user?.email_verified_at;

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loading className="mt-20" />
      </div>
    );
  }

  if (!user) return <Navigate to={ROUTES.LOGIN} replace />;

  if (isEmailVerified && !isUserInfoFilled(user)) {
    const handleUpdateUser = async (data: NewUserData) => {
      await userService.updateUser({
        surname: data.surname!,
        phone: data.phone!,
      });
      await loadUser();
    };

    return (
      <div className="p-8">
        <AccountCreationForm
          onSubmit={handleUpdateUser}
          isUpdate
          user={user}
        />
      </div>
    );
  }

  return (
    <div className="p-8">
      {(!isEmailVerified || user.role === ROLES.USER) && <UserJourneyPanel />}

      {isEmailVerified && isUserInfoFilled(user) && (
        <>
          {user.isAdmin && <AdminPanel />}
          {user.role === ROLES.DOCTOR && <DoctorPanel />}
        </>
      )}
    </div>
  );
};

export default Account;
